import {
  QuotaCritera,
  SimilarProjectsRequest,
} from '../../../shared/interfaces/similar-projects.interface';
import { SurveyPayload } from '../../../shared/interfaces/survey-meta-data.interface';

export class SimilarProjectDataMapper {
  survey: SurveyPayload;
  constructor(survey: SurveyPayload) {
    this.survey = survey;
  }

  public mapPayload(): SimilarProjectsRequest {
    const {
      completes_required,
      expected_ir,
      expected_loi,
      field_time,
      survey_localization,
      qualifications: payloadQualifications = [],
      quotas: payloadQuotas = [],
    } = this.survey;

    const qualifications = payloadQualifications?.map((qualification) => {
      const {
        qualification_code,
        condition_codes = [],
        range_sets = [],
      } = qualification;
      const conditions = condition_codes.length
        ? { condition_codes }
        : { range_sets };
      return {
        qualification_code: qualification_code,
        ...conditions,
      };
    });

    const quotas = payloadQuotas?.map((quota) => {
      const { required_count, number, quota_category, criteria = [] } = quota;
      return {
        required_count: number || required_count,
        quota_category: quota_category || 'layered',
        criteria: criteria.map((c) => {
          const {
            qualification_code,
            condition_codes = [],
            range_sets = [],
          } = c;
          const conditions = condition_codes.length
            ? { condition_codes }
            : { range_sets };
          return {
            qualification_code: qualification_code,
            ...conditions,
          } as QuotaCritera;
        }),
      };
    });

    return {
      survey_localization,
      completes_required,
      expected_ir,
      expected_loi,
      field_time,
      qualifications,
      quotas,
    };
  }
}
